module.exports = __webpack_public_path__ + "static/img/kjdy11.db79788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy11.png
// module id = 53
// module chunks = 0